import { Row, Col, Badge } from 'react-bootstrap'
import Product from '../../components/Product/Product'
import { Link, useParams } from 'react-router-dom'
import { useGetHomeDataQuery } from '../../slices/productsApiSlice.js'
import Loader from '../../components/Loader/Loader'
import Message from '../../components/Message/Message'
import Paginate from '../../components/Paginate/Paginate'
import Meta from '../../components/Meta/Meta'
import ProductCarousel from '../../components/ProductCarousel/ProductCarousel'
import './home.css'

const Home = () => {
  const { pageNumber, keyword } = useParams()
  const { data, isLoading, error } = useGetHomeDataQuery({
    keyword,
    pageNumber,
  })

  return (
    <>
      {isLoading ? (
        <div className="text-center my-5 premium-panel">
          <Loader />
          <p className="mt-3 text-muted">
            Loading products... This may take a little longer since the backend
            is running on a free hosting tier.
          </p>
        </div>
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          <section className="home-hero">
            <div className="home-hero-copy">
              <Badge className="home-kicker">Premium marketplace</Badge>
              <h1>Find products that feel made for your cart.</h1>
              <p>
                A smoother ShopWave experience with curated highlights, refined
                product browsing, and a checkout flow that stays out of the way.
              </p>
            </div>
            {!keyword ? (
              <ProductCarousel products={data.topProducts} />
            ) : (
              <Link to="/" className="btn btn-light mb-4">
                Back to all products
              </Link>
            )}
          </section>

          <Meta />
          <div className="section-heading-row">
            <div>
              <p className="section-eyebrow">Freshly stocked</p>
              <h2 className="home-heading">
                {keyword ? `Results for "${keyword}"` : 'Latest Products'}
              </h2>
            </div>
            <span className="catalog-count">
              {data.products.length} picks
            </span>
          </div>
          <Row className="product-grid">
            {data.products.map((product) => (
              <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
                <Product product={product} />
              </Col>
            ))}
          </Row>

          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword ? keyword : ''}
          />
        </>
      )}
    </>
  )
}

export default Home
